import styled, { keyframes } from "styled-components";


export const ErrorPageSection = styled.section`
        
`;

export const ErrorPageDetail = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    padding: 180px 0;
    height: 100vh;

    @media screen and (max-width: 467px){
        padding: 30px 0;
    }

    .primaryBtnWrap{
        margin: 0 auto;

        .btn.btn-primary{
            &:hover{
                color: rgb(65, 78, 92);
                background-color: transparent;
                border: 1px solid rgb(212, 61, 136);
            }
        }
    }

    h1{
        font-family: "Poppins", sans-serif;
            font-weight: 500;
            letter-spacing: 0px;
            font-size: 150px;
            color: #d43d88;
            text-shadow: 
            1px 1px 1px #112233,    
            2px 2px 1px #112233,
            3px 3px 1px #112233,
            4px 4px 1px #112233,
            5px 5px 1px #112233,
            6px 6px 1px #112233,
            7px 7px 1px #112233,
            8px 8px 1px #112233,
            25px 25px 8px rgba(0,0,0, 0.2);
            margin-bottom: 0;

            @media screen and (max-width: 991px){
                font-size: 120px;
            }

            @media screen and (max-width: 767px){
                font-size: 96px;
            }

            @media screen and (max-width: 467px){
                font-size: 76px;
            }
    }
`;


export const ErrorPageText = styled.p`
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    letter-spacing: 0px;
    margin: 2rem 0;
    font-size: 20px;
    font-weight: 600;
    color: #444;

    @media screen and (max-width: 767px){
        font-size: 16px;
        margin: 1rem 0;
    }
`;